import React, {Component} from 'react';
import styles from "../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import Button from "../../../../../components/button/Button";
import Icon from "../../../../../components/icon/Icon";
import MalattieService from "../../../../../services/MalattieService";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../utils/OggettiUtili"
import Select from "../../../../../components/select/Select"
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli";

const esitoTerapieMap = OggettiUtili.esitoTerapie;
const valoreNO = "495";
const valoreNONNOTO = "496";
const valoreNONNOTO2 = "496*";

class Terapia extends Component {

    state = {
        terapia: {
            listaTerapie: [{
                tipologia: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "496*" : "",
                farmaco: "",
                dataInizio: "",
                dataFine: "",
                esitoDellaTerapia: "",
            }],
            corretto: []
        },
        listaFarmaci: [],
        listaTipoTerapie: OggettiUtili.tipologiaTerapie,
        clicksTerapia: 0,
        boxesTerapia: [],
    }

    constructor(props) {
        super(props);
        this.handleChangeTipologia = this.handleChangeTipologia.bind(this);
        this.handleChangeFarmaco = this.handleChangeFarmaco.bind(this);
        this.handleChangeEsito = this.handleChangeEsito.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiungiElemento = this.aggiungiElemento.bind(this);
        this.aggiungiTerapia = this.aggiungiTerapia.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.validate = this.validate.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.setValori = this.setValori.bind(this)
        this.uniqueObjectTerapie = this.uniqueObjectTerapie.bind(this)
        this.eliminaRow = this.eliminaRow.bind(this)
    }

    componentDidMount() {

        MalattieService.getTerapie(this.props.malattia).then((data) => {
            let Farmaci = Utils.mapToArray(data.data);
            this.setState({listaFarmaci: Farmaci})
            this.setValori()

        }).catch(() => {
            this.setValori()
            console.log("errore chiamata getTerapie")
        });
    }

    createJsonForBackend() {
        let terapia = this.state.terapia
        let ObjectForBackEnd = {}
        let terapiaNew = Object.assign({}, JSON.parse(JSON.stringify(terapia)))
        let terapiaObj = Utils.removeFieldFromObject(terapiaNew, "corretto");
        ObjectForBackEnd["listaTerapie"] = Utils.removeEmptyValueFromObject(terapiaObj.listaTerapie)
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res
    }

    setValori() {

        let terapia = this.state.terapia

        if (this.props.segnalazioneCopia.datiSpecifici) {
            let terapiaCopia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici))
            if (terapiaCopia.terapia) {
                terapia.listaTerapie = terapiaCopia.terapia.listaTerapie ? terapiaCopia.terapia.listaTerapie : this.state.terapia.listaTerapie
            }
            this.setState({terapia: terapia});
            for (let i = 0; i < terapia.listaTerapie.length; i++) {
                this.aggiungiTerapia();
            }
        } else {
            this.aggiungiTerapia();
        }
        this.controllaDati()
        this.props.setTerapia(terapia, this)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clicksTerapia > this.state.clicksTerapia) {
            this.aggiungiTerapia()
            this.controllaDati();
        }
        if (prevState.terapia !== this.state.terapia) {
            this.controllaDati();
        }
        this.disabledSelectAutocomplete()
    }

    disabledSelectAutocomplete() {
        let condizione = this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
        Utils.disabledSelectAutocomplete(condizione)
    }

    controllaDati() {

        let terapia = this.state.terapia;
        terapia.corretto = []
        let controlloDati = {tipologia: false, farmaco: false, dataInizio: false, dataFine: false, esitoDellaTerapia: false}
        for (let i = 0; i < terapia.listaTerapie.length; i++) {

            if ((terapia.listaTerapie[i].tipologia === valoreNO || terapia.listaTerapie[i].tipologia === valoreNONNOTO || terapia.listaTerapie[i].tipologia === valoreNONNOTO2) && terapia.listaTerapie.length > 1) {
                terapia.corretto[0] = "Campo \"Tipologia (terapia/chemioprofilassi)\" da modificare inserendo un valore valido (diverso da \"NO\" oppure \"NON NOTO\") oppure eliminare la Terapia"
                controlloDati.tipologia = true
            }
        }

        if (controlloDati.tipologia === false) {
            for (let i = 0; i < terapia.listaTerapie.length; i++) {
                if ((terapia.listaTerapie[i].tipologia === null || terapia.listaTerapie[i].tipologia === undefined || terapia.listaTerapie[i].tipologia === "") && !controlloDati.tipologia) {
                    terapia.corretto[0] = "Campo \"Tipologia (terapia/chemioprofilassi)\" mancante"
                    controlloDati.tipologia = true
                }
                if (terapia.listaTerapie[i].tipologia !== valoreNO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO2 && (terapia.listaTerapie[i].farmaco === null || terapia.listaTerapie[i].farmaco === undefined || terapia.listaTerapie[i].farmaco === "") && !controlloDati.farmaco) {
                    terapia.corretto[1] = "Campo \"Farmaco\" mancante"
                    controlloDati.farmaco = true
                }
                if (terapia.listaTerapie[i].tipologia !== valoreNO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO2 && ((!terapia.listaTerapie[i].dataInizio) || (terapia.listaTerapie[i].dataInizio && Utils.isDateInValid(Utils.transformDateForBackend(terapia.listaTerapie[i].dataInizio), "-"))) && !controlloDati.dataInizio) {
                    terapia.corretto[2] = "Campo \"Data di inizio\" mancante o errato"
                    controlloDati.dataInizio = true
                }
                if (terapia.listaTerapie[i].tipologia !== valoreNO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO2 && terapia.listaTerapie[i].dataFine && Utils.isDateInValid(Utils.transformDateForBackend(terapia.listaTerapie[i].dataFine), "-")) {
                    terapia.corretto[3] = "Campo \"Data di fine\" errato"
                    controlloDati.dataFine = true
                }
                if (terapia.listaTerapie[i].tipologia === "450" && !terapia.listaTerapie[i].esitoDellaTerapia && !controlloDati.esitoDellaTerapia) {
                    terapia.corretto[4] = "Campo \"Esito della terapia\" mancante"
                    controlloDati.esitoDellaTerapia = true
                }
                if (terapia.listaTerapie[i].tipologia === "451" && !terapia.listaTerapie[i].esitoDellaTerapia && !controlloDati.esitoDellaTerapia) {
                    terapia.corretto[4] = "Campo \"Esito della terapia\" mancante"
                    controlloDati.esitoDellaTerapia = true
                }
                if (terapia.listaTerapie[i].tipologia !== valoreNO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO2 && (terapia.listaTerapie[i].farmaco === "169" || terapia.listaTerapie[i].farmaco === "497" || terapia.listaTerapie[i].farmaco === "498")) {
                    terapia.corretto[5] = "Campo \"Farmaco\" errato"
                    controlloDati.farmaco = true
                }
                if (terapia.listaTerapie[i].tipologia !== valoreNO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO && terapia.listaTerapie[i].tipologia !== valoreNONNOTO2 && terapia.listaTerapie[i].esitoDellaTerapia === "499") {
                    terapia.corretto[6] = "Campo \"Esito della terapia\" errato"
                    controlloDati.esitoDellaTerapia = true
                }
            }
        }

        this.setState({terapia: terapia})

        let res = this.createJsonForBackend()
        this.props.setTerapia(terapia, this, res)
    }

    validate() {

        for (let i = 0; i < this.state.terapia.listaTerapie.length; i++) {
            let validateDataInizio = Utils.checkDateInterval(this.state.terapia.listaTerapie[i].dataInizio, "31/12/1899");
            let checkTodayDataInizio = Utils.checkDateLowerToday(this.state.terapia.listaTerapie[i].dataInizio);
            let validateDataFine = Utils.checkDateInterval(this.state.terapia.listaTerapie[i].dataFine, "31/12/1899");
            let checkTodayDataFine = Utils.checkDateLowerToday(this.state.terapia.listaTerapie[i].dataFine);
            let confrontoDataInizioDataFine = Utils.checkDateIntervalMinore(this.state.terapia.listaTerapie[i].dataFine, this.state.terapia.listaTerapie[i].dataInizio);

            if (validateDataInizio) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0S"]), 1
                )
            } else if (checkTodayDataInizio) {
                return (
                    this.props.aggiungiToaster(["Messages.ERR_01_01_0F_0T"]), 1
                )

            }
            if (validateDataFine) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0U"]), 1
                )
            } else if (checkTodayDataFine) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_0V"]), 1
                )
            } else if (confrontoDataInizioDataFine) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_BS"]), 1
                )
            }
        }

        let terapia = JSON.parse(JSON.stringify(this.state.terapia.listaTerapie))

        let arraylistaTerapiaPulito = Utils.removeEmptyValueFromObject(terapia)


        let ObjectForBackEnd = {}
        let terapiaNew = Object.assign({}, this.uniqueObjectTerapie(arraylistaTerapiaPulito))
        let terapiaObj = Utils.removeFieldFromObject(terapiaNew, "corretto");
        ObjectForBackEnd["listaTerapie"] = Utils.removeEmptyValueFromObject(terapiaObj.listaTerapie)

        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);


        this.props.setTerapia(this.state.terapia, this, res)
    }

    riceviValore(field) {

        let click = this.state.clicksTerapia - 1
        let data = this.state.terapia

        if (field.currentTarget.id.includes("dataFine")) {
            let indice = field.currentTarget.id.replace("dataFine", "")
            data.listaTerapie[indice].dataFine = field.target.value
        } else if (field.currentTarget.id.includes("dataInizio")) {
            let indice = field.currentTarget.id.replace("dataInizio", "")
            data.listaTerapie[indice].dataInizio = field.target.value
        }

        this.setState({terapia: data, clicksTerapia: click});

        this.controllaDati();
    }

    uniqueObjectTerapie(elTerapie) {
        const tmpTerapie = new Map()

        let terapia = JSON.parse(JSON.stringify(this.state.terapia))

        const rsTerapie = elTerapie.reduce((acc, e) => {
            if (tmpTerapie.has(e.tipologia) && tmpTerapie.has(e.farmaco) && tmpTerapie.has(e.dataInizio) && tmpTerapie.has(e.dataFine) && tmpTerapie.has(e.esitoDellaTerapia)
            ) {
                if (!tmpTerapie.get(e.tipologia).includes(e.jobid) &&
                    !tmpTerapie.get(e.farmaco).includes(e.jobid) &&
                    !tmpTerapie.get(e.dataInizio).includes(e.jobid) &&
                    !tmpTerapie.get(e.dataFine).includes(e.jobid) &&
                    !tmpTerapie.get(e.esitoDellaTerapia).includes(e.jobid)
                ) {
                    acc.push(e)
                    tmpTerapie.set(e.tipologia, [...tmpTerapie.get(e.tipologia), e.jobid])
                    tmpTerapie.set(e.farmaco, [...tmpTerapie.get(e.farmaco), e.jobid])
                    tmpTerapie.set(e.dataInizio, [...tmpTerapie.get(e.dataInizio), e.jobid])
                    tmpTerapie.set(e.dataFine, [...tmpTerapie.get(e.dataFine), e.jobid])
                    tmpTerapie.set(e.esitoDellaTerapia, [...tmpTerapie.get(e.esitoDellaTerapia), e.jobid])
                }
            } else {
                acc.push(e)
                tmpTerapie.set(e.tipologia, [e.jobid])
                tmpTerapie.set(e.farmaco, [e.jobid])
                tmpTerapie.set(e.dataInizio, [e.jobid])
                tmpTerapie.set(e.dataFine, [e.jobid])
                tmpTerapie.set(e.esitoDellaTerapia, [e.jobid])
            }
            return acc
        }, [])

        terapia.listaTerapie = rsTerapie

        return terapia
    }


    handleChangeTipologia(event) {

        let click = this.state.clicksTerapia - 1
        let tipologia = this.state.terapia
        tipologia.listaTerapie[event.target.id].tipologia = event.target.value
        tipologia.listaTerapie[event.target.id].farmaco = ""
        tipologia.listaTerapie[event.target.id].dataInizio = ""
        tipologia.listaTerapie[event.target.id].dataFine = ""
        tipologia.listaTerapie[event.target.id].esitoDellaTerapia = ""
        this.setState({terapia: tipologia, clicksTerapia: click});
        this.controllaDati();

    }

    handleChangeFarmaco(event) {
        let click = this.state.clicksTerapia - 1
        let farmaco = this.state.terapia
        farmaco.listaTerapie[event.target.id].farmaco = event.target.value
        this.setState({terapia: farmaco, clicksTerapia: click});
        this.controllaDati();
    }

    handleChangeEsito(event) {
        let click = this.state.clicksTerapia - 1
        let esito = this.state.terapia
        esito.listaTerapie[event.target.id].esitoDellaTerapia = event.target.value
        this.setState({terapia: esito, clicksTerapia: click});
        this.controllaDati();
    }

    aggiungiElemento() {

        let terapiaCopia = this.state.terapia;
        terapiaCopia.listaTerapie.push({
            tipologia: "",
            farmaco: "",
            dataInizio: "",
            dataFine: "",
            esitoDellaTerapia: ""
        })
        this.setState({terapia: terapiaCopia})
        this.controllaDati()
    }

    eliminaRow(i){
        let terapia = this.state.terapia;
        let boxesTerapia = this.state.boxesTerapia
        let clicksTerapia = this.state.clicksTerapia
        terapia.listaTerapie.splice(i,1)
        boxesTerapia.splice(i,1)
        this.setState({boxesTerapia: boxesTerapia, terapia: terapia});
        if(i===1) clicksTerapia = clicksTerapia - 1
        else clicksTerapia = clicksTerapia - 2
        this.aggiungiTerapia(clicksTerapia)
    }

    aggiungiTerapia(clicksTerapia) {
        let terapie = this.state.terapia.listaTerapie;
        let clicks = clicksTerapia ? clicksTerapia : this.state.clicksTerapia===this.state.terapia.listaTerapie.length ? this.state.clicksTerapia : this.state.clicksTerapia + 1;
        let boxesTerapia = [];
        for (let i = 0; i < clicks; i++)
            boxesTerapia.push(
                <div style={{marginTop: "2rem"}}>
                    <div className="row">
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9"}}>{this.props.t("DatiSpecifici.Terapia.tipologia")}<span
                                className={styles.mandatoryColor}>*</span></p>
                            <Select
                                value={this.state.terapia.listaTerapie[i].tipologia === "496*"? "496" : this.state.terapia.listaTerapie[i].tipologia}
                                onChange={this.handleChangeTipologia}
                                id={i}
                                functionMap={this.state.listaTipoTerapie.map((oggetto) => {
                                    return (<option value={oggetto.codice} style={{backgroundColor:'white'}}>{oggetto.descrizione}</option>)
                                })}
                                addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.terapia.listaTerapie[i].tipologia === "496*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                                >

                            </Select>
                        </div>
                        <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9"}}>{this.props.t("DatiSpecifici.Terapia.farmaco")}
                                {this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2 ? null :
                                    <span className={styles.mandatoryColor}>*</span>}
                            </p>
                            <SelectAutocomplete
                                value={this.state.terapia.listaTerapie[i].farmaco}
                                onChange={this.handleChangeFarmaco}
                                disabled={this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2 || (this.props.segnalazioneCopia.migrazione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia && (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)))}
                                id={i}
                                functionMap={this.state.listaFarmaci.map((oggetto) => {
                                    return (<option value={oggetto.codiceTerapia}>{oggetto.descrizioneTerapia}</option>)
                                })}>

                            </SelectAutocomplete>
                        </div>
                        <div className={"col-lg-2"}>
                            {
                                i>0 && !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                    <span id={"elimina"+i}
                                          onClick={()=>
                                              this.eliminaRow(i)

                                          }
                                    ><Icon id={"it-delete"} style={{fill: "red",float: "right", marginTop: "1.6rem", cursor: "pointer"}} /></span>
                                    : <></>
                            }
                        </div>
                    </div>

                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <div>
                                <p className={styles.testo} style={{color: "#1b7ea9"}}>
                                    {this.props.t("DatiSpecifici.Terapia.dataInizio")}
                                    {this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2? null :
                                        <span className={styles.mandatoryColor}>*</span>}
                                </p>
                                <Calendar
                                    id={"dataInizio".concat(i)}
                                    value={this.state.terapia.listaTerapie[i].dataInizio}
                                    field={"dataInizio".concat(i)}
                                    onChange={this.riceviValore}
                                    errorMessage={"Data non valida"}
                                    error={(this.state.terapia.listaTerapie[i].dataInizio === "" ||
                                        this.state.terapia.listaTerapie[i].dataInizio == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.terapia.listaTerapie[i].dataInizio), "-")}
                                    disabled={this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2}
                                >
                                </Calendar>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo} style={{color: "#1b7ea9"}}>
                                {this.props.t("DatiSpecifici.Terapia.dataFine")}
                            </p>
                            <Calendar
                                id={"dataFine".concat(i)}
                                value={terapie[i].dataFine}
                                field={"dataFine".concat(i)}
                                onChange={this.riceviValore}
                                errorMessage={"Data non valida"}
                                error={(terapie[i].dataFine === "" ||
                                    terapie[i].dataFine == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(terapie[i].dataFine), "-")}
                                disabled={this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2}
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>
                                {this.props.t("DatiSpecifici.Terapia.esito")}
                                {this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2? null :
                                    terapie[i].tipologia === "450" || terapie[i].tipologia === "451" ?
                                        <span className={styles.mandatoryColor}>*</span> : null}
                            </p>
                            <div>
                                <Select
                                    value={terapie[i].esitoDellaTerapia}
                                    onChange={this.handleChangeEsito}
                                    id={i}
                                    disabled={this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2}
                                    functionMap={esitoTerapieMap.map((oggetto) => {
                                        return (<option value={oggetto.code}>{oggetto.displayName}</option>)
                                    })}>
                                </Select>
                            </div>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                             style={{marginTop: "2rem"}}>
                            {i < 1 ? <Button
                                onClick={() => {
                                    this.aggiungiElemento();
                                    this.aggiungiTerapia()
                                }} className={styles.testo}
                                classes="btn mt-2 btnBluOutline mb-1 "
                                style={{
                                    border: "none", background: "none", float: "right", fontSize: "16px",
                                    opacity: (this.props.segnalazioneCopia.migrazione || this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "0.5" : ""
                                }}
                                text="Aggiungi terapia "
                                icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                disabled={this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO || this.state.terapia.listaTerapie[i].tipologia === valoreNO || this.state.terapia.listaTerapie[i].tipologia === valoreNONNOTO2}
                            /> : <div/>}
                        </div>
                    </div>
                </div>
            )
        this.setState({boxesTerapia: boxesTerapia, clicksTerapia: clicks});
        this.controllaDati()
    }

    render() {
        const {t} = this.props;
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("DatiSpecifici.Terapia.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>

                    {this.state.boxesTerapia}
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(Terapia);
